var React = require('react');

function Bag (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#F3008C;}\n"),React.createElement("g",{"key":1},[React.createElement("path",{"className":"st0","d":"M141.7,49.6c-0.1-3-2.5-5.3-5.5-5.3H38.8c-3,0-5.4,2.3-5.5,5.3l-4,108.5c-0.1,1.5,0.5,2.9,1.5,4\n\t\tc1,1.1,2.5,1.7,4,1.7h105.4c1.5,0,2.9-0.6,4-1.7c1-1.1,1.6-2.5,1.5-4L141.7,49.6z M40.5,152.8l3.6-97.5h86.8l3.6,97.5H40.5z","key":0}),React.createElement("path",{"className":"st0","d":"M87.5,22.2c10.4,0,18.8,8.5,18.8,18.8h11c0-16.5-13.4-29.8-29.8-29.8S57.7,24.6,57.7,41h11\n\t\tC68.7,30.6,77.1,22.2,87.5,22.2z","key":1})])]);
}

Bag.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 175 175","style":{"enableBackground":"new 0 0 175 175"},"xmlSpace":"preserve"};

module.exports = Bag;

Bag.default = Bag;
